import { TitleObjectType } from '@/interfaces/titles';
import { ObjectType } from '@/@types/graphql-types';

export const EntityHelper = {
	/**
	 * merge an objectType and objectId into an string like `tm123` or `ts1`
	 */
	getEntityId: (objectType: string, objectId: number) => {
		let str = 't';
		switch (objectType) {
			case TitleObjectType.MOVIE:
				str += 'm';
				break;
			case TitleObjectType.SHOW:
				str += 's';
				break;
			case TitleObjectType.SEASON:
				str += 'ss';
				break;
			case TitleObjectType.EPISODE:
				str += 'se';
				break;
			case TitleObjectType.PERSON:
				str += 'p';
				break;
			default:
				console.log(`[ERROR] ${objectType} is not a valid object type`);
		}
		return str + `${objectId}`;
	},

	/**
	 * merge an objectType and objectId into an string like `tm123` or `ts1`
	 * specifically for the SnowPlowTitleContext
	 */
	getTitleContextEntityId: (objectType: string, objectId: number) => {
		let str = 't';
		switch (objectType) {
			case TitleObjectType.MOVIE:
				str += 'm';
				break;
			case TitleObjectType.SHOW:
			case TitleObjectType.SEASON:
			case TitleObjectType.EPISODE:
				str += 's';
				break;
			case TitleObjectType.PERSON:
				str += 'p';
				break;
			case TitleObjectType.LEAVING_SOON:
				str += 'ls';
				break;
			case TitleObjectType.SPORTS_GAME:
				str = 'sg';
				break;
			default:
				console.log(`[ERROR] ${objectType} is not a valid object type`);
		}
		return str + `${objectId}`;
	},

	getTitleContextEntityIdGraphql: (objectType: ObjectType, objectId: number) => {
		let str = 't';
		switch (objectType) {
			case ObjectType.Movie:
				str += 'm';
				break;
			case ObjectType.Show:
			case ObjectType.ShowSeason:
			case ObjectType.ShowEpisode:
				str += 's';
				break;
			case ObjectType.Person:
				str += 'p';
				break;
			// TODO: [GraphQL] Add this ObjectType to GraphQL schema or talk to BI about using one of existing
			// case ObjectType.LEAVING_SOON:
			// 	str += 'ls';
			// 	break;
			default:
				console.log(`[ERROR] ${objectType} is not a valid object type`);
		}
		return str + `${objectId}`;
	},

	/**
	 * splits a string into an objectType and objectId, if they look like `tm123` or `ts1`.
	 */
	splitEntityId: (str: string): { objectType: TitleObjectType; objectId: number } | undefined => {
		if (!str) {
			return undefined;
		}

		const matches = /^t(m|s|ss|se|p)(\d+)$/.exec(str);
		if (!matches || !matches.length || matches.length < 3) {
			return undefined;
		}
		const OBJECT_TYPES = {
			m: TitleObjectType.MOVIE,
			s: TitleObjectType.SHOW,
			ss: TitleObjectType.SEASON,
			se: TitleObjectType.EPISODE,
			p: TitleObjectType.PERSON,
		};

		return {
			objectType: (OBJECT_TYPES as any)[matches[1]] as TitleObjectType,
			objectId: parseInt(matches[2]),
		};
	},
};
